import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Refresh = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 28H16C9.387 28 4 22.613 4 16C4 12.512 5.463 9.262 8 7.012V9C8 9.55 8.45 10 9 10C9.55 10 10 9.55 10 9V5C10 4.45 9.55 4 9 4H5C4.45 4 4 4.45 4 5C4 5.55 4.45 6 5 6H6.15C3.512 8.6 2 12.175 2 16C2 23.725 8.275 30 16 30H17C17.55 30 18 29.55 18 29C18 28.45 17.55 28 17 28Z" />
		<path d="M27 26H25.85C28.487 23.4 30 19.825 30 16C30 8.275 23.725 2 16 2H15C14.45 2 14 2.45 14 3C14 3.55 14.45 4 15 4H16C22.613 4 28 9.387 28 16C28 19.488 26.538 22.738 24 24.988V23C24 22.45 23.55 22 23 22C22.45 22 22 22.45 22 23V27C22 27.55 22.45 28 23 28H27C27.55 28 28 27.55 28 27C28 26.45 27.55 26 27 26Z" />
	</svg>
);

export default Refresh;
